export const COST_BOM_DEMO_STRINGS = {
  title: 'Cost model in Minutes not Days',
  titleGradient: 'Cost model ',
  titleSuffix: 'in Minutes not Days',
  subtitle: 'Iterate on cost models faster with Muir AI. Try it below.',
  buildingLabel: 'I am building ',
  sourcingFrom: ' sourcing from ',
  generate: 'Generate Cost Model',
  generating: 'Generating…',
  buildYourOwn: 'Build Your Own Cost Model',
  addSample: 'View another sample',
  yourOwnProduct: 'Your own product +',
  describeProduct: 'Describe your product & sourcing',
  buildModelHint: 'Build a model for your product',
  conversionTitle: 'Build your own cost model',
  productName: 'Product name',
  sourcingFromLabel: 'Sourcing from',
  searchCountries: 'Search countries',
  clearCountry: 'Clear country',
  noCountriesFound: 'No countries found',
  workEmail: 'Work email',
  startDraft: 'Send Me Draft Cost Model',
  talkToExpert: 'Talk to an Expert',
  reviewWithExpert: 'Review Model with Expert',
  conversionError: 'Please fill in all fields with a valid work email.',
  successTitle: 'Your Cost Model is on the way!',
  successDefault:
    "Thank you for requesting the model and we'll send it soon, in the meantime you can schedule time with our expert here:",
  businessEmailError: 'Please use a business email address',
  emailRequired: 'Email is required',
} as const

export const SAMPLE_PRODUCTS = [
  {
    product: 'NMC Battery Cell',
    country: 'China',
    key: 'nmc',
  },
  {
    product: 'Citric Acid',
    country: 'Germany',
    key: 'citric',
  },
  {
    product: 'Smart Home SoC',
    country: 'Taiwan',
    key: 'soc',
  },
] as const
